import React, { useState } from 'react'
 
 
import ProcurementRecieptList from './ProcurementRecieptList';
import ProcurementRecieptForm from './ProcurementRecieptForm';

const ProcurementReciept= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <ProcurementRecieptForm addForm={setFromIsShown} update={upData}  sId={serviceId}/>
        ) : (
          <ProcurementRecieptList addForm={setFromIsShown} update={setUpData}  sId={setServiceId}/>
        )}  
    </>
  )
}

export default ProcurementReciept